import comp from "./TagPostV2";
export default comp;
